import { Component, ElementRef, OnInit, Input, ViewChild, Output, AfterViewInit, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef } from '@angular/core';
import { State, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { InvoiceCollectionNotesBus } from '@app/cp/shared/models/InvoiceCollectionNotesBus';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { InvoiceBus } from '@app/cp/shared/models/InvoiceBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { CommonValues } from '../../shared/static/CommonValues';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
  selector: 'collection-notes',
  templateUrl: './collection-notes.component.html',
  styleUrls: ['./collection-notes.component.scss']
})
export class CollectionNotesComponent extends BaseGridEditFormLinesComponent<InvoiceCollectionNotesBus, null, InvoiceService> {
    //collectionNoteCodeFC: MSFilterClass = new MSFilterClass('statusName');
    collectionNoteCodeCF: MSCLFilterClass;
    personCF: MSCLFilterClass;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "InvoiceCollectionNotesBus";
        this.appCode = "CollectionNotes";
        this.appName = "Collection Notes";
        this.disableCpSearchDialog();
    }
    @Input() parentObj: InvoiceBus;
    protected afterAddNewData() {
        super.afterAddNewData();
        if (this._addOnly) {
            this.selectedData.collectionNoteCodeId = CommonValues.CollectionNoteCodes_DisputedInvoice;
        }
    }
    protected _noteElemElemRef: ElementRef;
    @ViewChild('noteElem') set noteElem(content: ElementRef) {
        if (content) { // initially setter gets called with undefined

            this._noteElemElemRef = content;
            //    if (this.data) {
            //        this.creditMemoReason = this.data.creditMemoReason;
            //    }
        }
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    get note(): string {
        return this._noteElemElemRef ? this._noteElemElemRef.nativeElement.value : "";
    }
    set note(value: string) {
        if (this._noteElemElemRef) {
            this._noteElemElemRef.nativeElement.value = value;
        }
    }

    close(e: any) {
        super.close(e);
        this._addOnly = false;
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'invoiceCollectionNoteId': new UntypedFormControl(),
            'invoiceId': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'note': new UntypedFormControl(''),
            'collectionNoteCodeId': new UntypedFormControl('', Validators.required),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'collectionNoteCode': new UntypedFormControl(),

        });
    }
    setForm() {
        this.editForm.patchValue({
            invoiceCollectionNoteId: this.selectedData.invoiceCollectionNoteId,
            invoiceId: this.selectedData.invoiceId,
            personId: this.selectedData.personId,
            note: this.selectedData.note,
            collectionNoteCodeId: this.selectedData.collectionNoteCodeId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            personName: this.selectedData.personName,
            collectionNoteCode: this.selectedData.collectionNoteCode
        });
        this.note = this.selectedData.note;
    }
    customCanSaveForm() {
        return CommonFunctions.hasStringValue(this.note);
    }
    setFromReferenceData(data: InvoiceCollectionNotesBus) {
        data.personName = this.personName(data.personId);
        data.collectionNoteCode = this.referenceData.getCollectionNoteCodeDesc(data.collectionNoteCodeId);
        return data;
    }
    get inFinance(): boolean {
        return CommonFunctions.hasValue(this.parentObj) ? this.parentObj.inFinance : false;
    }
    canEditRow(dataItem: InvoiceCollectionNotesBus) {
        console.log("coll-notes: ", dataItem);
        return this.isNew; //and has rights
    }
    protected getChangedObject(data: InvoiceCollectionNotesBus) {
        data.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        data.setParentId(this._parentId);
        data = this.setFromReferenceData(data);
        data.note = this.note;
        data.setBeforeSave();
        return data;
    }
    protected save(dataObj: InvoiceCollectionNotesBus) {

        let busObj: InvoiceCollectionNotesBus = this.getChangedObject(dataObj);
        this.svc_data.saveCollectionNote(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let newDataObj: InvoiceCollectionNotesBus = new InvoiceCollectionNotesBus(info.primaryReturn);
                this.saveSuccess(newDataObj);
            }
            else {
                this.saveError(dataObj, "Error Saving");
            }
        });
    }

    //deleteIndividual(data: InvoiceCollectionNotesBus) {
    //    if (data.hasId) {
    //        this.svc_data.deleteNote(data.dispatchNotesId).subscribe((dataObj: BaseMessageInfo) => {
    //            if (!dataObj.saveError) {
    //                let delDataObj: v_DispatchNoteBus = new v_DispatchNoteBus(data);

    //                this.deleteSuccess(delDataObj);
    //                this.removeLocal(delDataObj);
    //            }
    //            else {
    //                this.deleteError(data, dataObj.message);

    //            }
    //        });
    //    }
    //    else {
    //        this.closeEditor();
    //    }
    //}
    //get canEditNote(): boolean {
    //    let can: boolean = false;

    //    if (this.canEdit && this.selectedData) {
    //        if (this.selectedData.personId != this.globals.personId && this.canEditOthersNotes) {
    //            can = true;
    //        }
    //    }

    //    return can;
    //}
    processGridData() {
        this.collectionNoteCodeCF = new MSCLFilterClass('collectionNoteCode', 'collectionNoteCode', this.gridData);
        this.personCF = new MSCLFilterClass('personName', 'personName', this.gridData);
    }
    test1() {
        console.log("test: ", this, this.gridData);
    }
}

